import Vue from 'vue';
import productFlowTransformer from './../../transformers/productFlow';
import store from '../../store';

const success = ({ data }, resolve) => {
  const productFlow = productFlowTransformer.fetch(data);
  resolve(productFlow);
  store.dispatch('fetchCurrentproductFlow', productFlow);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/productflow/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productFlow/show.js